<div class="col-12 col-t-12 col-s-12 footer">
    <div class="col-12 col-t-12 col-s-12 logo">
        <img class="logito" [src]=logoW>
    </div>
    <div class="col-12 col-t-12 col-s-12 text">
        <p>© 2020 groupmon.com | Todos los derechos reservados</p>
    </div>
    <div class="col-3 col-t-8 col-s-8 social">
        <div class="col-4 col-t-12 col-s-12 redSocial">
            <i class="fab fa-instagram"></i>
        </div>
        <div class="col-4 col-t-12 col-s-12 redSocial">
            <i class="fab fa-twitter"></i>
        </div>
        <div class="col-4 col-t-12 col-s-12 redSocial">
            <i class="fab fa-facebook-f"></i>
        </div>
    </div>
    <div class="col-12 col-t-12 col-s-12 email">
        <p>info@groupmon.com</p>
    </div>
</div>
